import React, { memo } from "react";
import "swiper/css";
import "swiper/css/free-mode";
import "./Partners.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import { Fade } from "react-awesome-reveal";
import { OurSolIcon } from "../../assets/img";
import { useTranslation } from "react-i18next";

const renderSwiperSlide = (sector, idx) => (
	<SwiperSlide key={idx}>
		<Fade
			direction='up'
			triggerOnce={true}
			className='py-6 px-6 border-[1px] border-slate-100 rounded-md shadow-md'>
			<img
				loading='lazy'
				className='h-16 m-auto'
				src={sector?.logo}
				alt={sector?.name || "Partner Logo"}
			/>
		</Fade>
	</SwiperSlide>
);

const Partners = memo(({ title, sliderData }) => {
	const { i18n } = useTranslation();
	const swiperConfig = {
		slidesPerView: 1,
		spaceBetween: 16,
		freeMode: true,
		navigation: false,
		loop: true,
		dir: i18n?.language === "ar" ? "rtl" : "ltr",
		autoplay: {
			delay: 3000,
			disableOnInteraction: false,
		},
		breakpoints: {
			992: { slidesPerView: 4, spaceBetween: 20 },
			768: { slidesPerView: 5, spaceBetween: 20 },
		},
		modules: [FreeMode, Autoplay],
		className: "partners-slides h-32",
	};

	return (
		<section className='pt-32 pb-16 relative md:px-12 px-6 bg-white'>
			<div>
				<div className='flex justify-center items-center gap-2 mb-6'>
					<img
						loading='lazy'
						className='rotate-animate'
						src={OurSolIcon}
						alt='Partners Icon'
					/>
					<h3 className='text-second_color font-semibold md:text-4xl text-3xl'>
						{title}
					</h3>
				</div>
				<Swiper {...swiperConfig}>{sliderData?.map(renderSwiperSlide)}</Swiper>
			</div>
		</section>
	);
});

export default Partners;
